import { render } from "./VisitorParentSearch.vue?vue&type=template&id=f5a77758"
import script from "./VisitorParentSearch.vue?vue&type=script&lang=js"
export * from "./VisitorParentSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__